/**
 * Created by razial on 2026-05-21.
 */

class EffectsComponent extends BaseComponent {
    onCreate() {
        // a prefab may bind an effect to its theme ("#theme.openSound"); a plain { bundle, sound } passes through
        this.map = {};
        for (const effect in this.options.map || {}) {
            this.map[effect] = PrefabBuilder.resolveProperty(this.options.map[effect], this.context);
        }
    }

    findEffects(effectName) {
        return cleverapps.toArray(this.map[effectName]);
    }
}

Prefab.registerComponent("EffectsComponent", EffectsComponent);
